<ng-container *ngIf="!isMobile; else elseBlock">
    <!-- ['/mobilaty-stars'] -->
    <button
        class="header-icon "
        [routerLink]="['/' + lang + '/account/wallet-history']"
        mat-mini-fab
        #menuTrigger="matMenuTrigger"
        matBadgePosition="after"
        (mouseenter)="toggleMenu($event, true)"
        (mouseleave)="toggleMenu($event, false)"
        [matMenuTriggerFor]="viewList"
        [ngClass]="{
            'white-outline':
                environmentVariables?.ENABLE_HEADER_ICONS_BACKGROUND === false,
            'icons-background':
                environmentVariables?.HEADER_ICONS_BACKGROUND_COLOR &&
                environmentVariables?.ENABLE_HEADER_ICONS_BACKGROUND,
            'defult-background-icons':
                !environmentVariables?.HEADER_ICONS_BACKGROUND_COLOR
        }"
    >
        <mat-icon
        (mouseover)="changeIconFill=false"
        (mouseleave)="changeIconFill=true"
            id="favIcon"
            class="material-icons notranslate defulat-icons-color "
            [ngClass]="{
                'material-symbols-outlined':
                (!environmentVariables?.ENABLE_HEADER_ICONS_FILL && changeIconFill),
                'icons-fill-color':
                    environmentVariables?.HEADER_ICONS_FILL_COLOR
            }"
        >
            account_balance_wallet
        </mat-icon>
    </button>

    <mat-menu #viewList="matMenu" [hasBackdrop]="false">
        <div
            class="drop-wrap"
            (mouseenter)="this.enteredMenu = true"
            (mouseleave)="closeMatMenu()"
        >
            <div class="cart-menu-list p-2" fxLayoutAlign="start center">
                <div class="px-3">
                    <h6 class="mb-0">
                        <p class="m-0">
                            {{ "wallet.total_wallet" | translate }}
                            <span>
                                ({{ user?.wallet_balance }}
                                {{
                                    lang == "en"
                                        ? environmentVariables?.CURRENCY_CODE_EN
                                        : environmentVariables?.CURRENCY_CODE_AR
                                }})
                            </span>
                        </p>
                    </h6>
                </div>
            </div>
            <div class="footer-menu px-3 pb-2 pt-2">
                <button
                    mat-raised-button
                    color="accent"
                    class="w-100 color-primary "
                    (click)="checkUserGuest()"
                >
                    {{ "button.viewWallet" | translate }}
                </button>
            </div>
        </div>
    </mat-menu>
</ng-container>
<ng-template #elseBlock>
    <button
        class="header-icon "
        [ngClass]="{
            'white-outline':
                environmentVariables?.ENABLE_HEADER_ICONS_BACKGROUND === false,
            'icons-background':
                environmentVariables?.HEADER_ICONS_BACKGROUND_COLOR &&
                environmentVariables?.ENABLE_HEADER_ICONS_BACKGROUND,
            'defult-background-icons':
                !environmentVariables?.HEADER_ICONS_BACKGROUND_COLOR
        }"
        [routerLink]="['/' + lang + '/account/wallet-history']"
        (click)="checkUserGuest()"
        mat-mini-fab
        matBadgePosition="after"
    >
        <mat-icon class="material-icons notranslate  defulat-icons-color"
        [ngClass]="{
          'material-symbols-outlined':
              !environmentVariables?.ENABLE_HEADER_ICONS_FILL,
          'icons-fill-color':
              environmentVariables?.HEADER_ICONS_FILL_COLOR
      }" >
            account_balance_wallet
        </mat-icon>
    </button>
</ng-template>
